import React from 'react';
import styled from 'styled-components';
import { Title } from '../../UI/Typography';
import { Container } from '../../UI/Containers';
import CompanyCalendar from '../Attendancecomponents/CompanyCalendar';

const PageContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.background};
  max-width: 1200px;
  margin: 0 auto;
`;

function AttendanceSettings() {
  return (
    <PageContainer>
      <Title>Attendance Settings</Title>
      <CompanyCalendar />
    </PageContainer>
  );
}

export default AttendanceSettings;
